import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TimeService } from 'src/app/services/time/time.service';

@Component({
  selector: 'app-lobmanagement',
  templateUrl: './lobmanagement.component.html',
  styleUrls: ['./lobmanagement.component.css']
})
export class LOBManagementComponent implements OnInit {

  lambdaMessage = ""
  lambdaMessage2= ""
  lambdaError = false;
  lambdaError2 = false;
  formValid = true;
  languages = ["en-US","es-ES","es-US"]
  availableQueues = []  //queues that have not been added yet
  data = []             //queue table input
  fullData = []         //list of all queues
  fullGroups=[]
  groups=[]
  lobs=[]
  lobSelected="Select LOB"
  currentUser;
  overFlowSelect: string = 'default';
  bluePrint= {'queueName': '', 'queueConfig':{'overFlow':{}}, 'queueId':this.newGUID()};

  transferObj = {behavior: 'transfer', arn: null, transferNumber: '+1'};
  queueObj = {behavior: 'queue', arn: '', transferNumber: null};

  queueNameOptions: Array<string> = [];
  undefinedQueues = [];                   // {name: string, arn: string}
  langMap: Map<string, any>;

  constructor(private telecomService:TelecomService, private auth: AuthService, private time: TimeService) { }

  ngOnInit(): void {
    this.getQueues()
    this.getLOBs()
    this.getGroups()
    this.buildLangMap();
    // this.getApplicationData()
    this.currentUser = this.auth.userPool.getCurrentUser().username;
    this.currentUser = this.currentUser.split("_")[1].split('@')[0];
    console.log(this.currentUser);
  }

  newGUID(){
    return Guid.create()['value'];
  }

  // getApplicationData(){
  //   let params = {
  //     FunctionName: environment.ApplicationDataLambdaName,
  //     Payload: JSON.stringify({
  //       operation: 'get',
  //       collections: [
  //         "LOBList",
  //         "languageList",
  //         "queueGroupList"
  //       ]
  //     })
  //   }
  //   this.telecomService.callLambda(params, "Failed to retrieve config data.").then((data:any)=>{
  //     if(data.status == 200){
  //       console.log("applicationData: ", data);
  //     }else{
  //       this.lambdaError = true;
  //       this.lambdaMessage = "Failed to retrieve config data";
  //       console.error("Error: ", data);
  //     }
  //   })
  // }

  getQueues(){
    this.telecomService.getRows(environment.QueuesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.fullData = data.body.queueList;
        this.updateLocalData(this.lobSelected);
      }
      else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log("Error: ", data.Error)
      }
    });
  }

  getLOBs(){
    this.lobs = this.telecomService.lobList;
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobs = resultData.lobList;
      this.updateLocalData(this.lobSelected);
    });
  }

  getGroups(){
    this.telecomService.getRows(environment.GroupsLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.fullGroups = data.body.Group.Item.data;
      }
      else{
        this.lambdaError2 = true;
        this.lambdaMessage2 = data.Error.message;
        console.log("Error: ", data.Error)
      }
    });
  }

  //retrieves queues from connect that have not yet been "created" in dynamodb queue table
  getUndefinedQueues(){
    let params = {
      FunctionName: environment.QueueListLambdaName,
      Payload: JSON.stringify({})
    };
    this.telecomService.callLambda(params, "Failed to retreive available queues.").then((data: any) => {
      if(data.statusCode == 200){
        this.undefinedQueues = data.body.queues;
        this.queueNameOptions = [];
        for(let x=0; x < this.undefinedQueues.length; x++){
          this.queueNameOptions.push(this.undefinedQueues[x]['Name']);
        }
      }
    });
  }

  //update table item
  updateItem(tableData){
    console.log(tableData);
    if(tableData.action == "error"){
      console.log('setting lambda2 notificaton');
      console.log(tableData.item);
      this.lambdaMessage2 = tableData.item;
      this.lambdaError2 = true;
      return;
    }
    if(this.lobSelected == "Select LOB"){
      console.error("User must select an LOB for the queue.");
      this.lambdaError = true;
      this.lambdaMessage = "User must select an LOB for the queue.";
      return;
    }
    tableData.item.LOB = this.lobSelected;
    tableData.item.updatedBy = this.currentUser;
    let now = this.time.wireFormatDate(new Date(), 0);
    tableData.item.lastUpdated = now;

    console.log(tableData.item);
    //update local queue data. had to check for queueConfig because also being used
    //by the group editor
    if(tableData.action == 'put' && 'queueConfig' in tableData.item){
      let index = this.data.findIndex(queue => queue.queueId == tableData.item.queueId);
      let temp = JSON.parse(JSON.stringify(this.data));
      temp[index] = tableData.item;
      this.data = temp;
      console.log(this.data);
    }

    this.bluePrint['queueId'] = this.newGUID();

    //put or delete
    this.telecomService.saveRow(tableData, environment.QueuesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Data updated successfully.";
        this.getQueues();
      }else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log("Error: ", data.Error);
        if(tableData.action == "put"){
          this.lambdaMessage = "An error occurred, data was not saved successfully.";
        }
        else if(tableData.action == "delete"){
          this.lambdaMessage = "An error occurred, data was not deleted successfully.";
        }
      }
    });
  }

  changeLOB(lob){
    //fill full data with the data saved in the table, then clear the data in data
    this.getQueues()
    this.getGroups()
    this.updateLocalData(lob);
  }

  updateLocalData(lob){
    this.data = [];
    this.groups = [];
    for (let i =0; i<this.fullData.length; i++){
      if(this.fullData[i].LOB == lob){
        this.data.push(this.fullData[i])
      }
    }
    for (let i=0; i<this.fullGroups.length; i++){
      if(this.fullGroups[i].LOB == lob){
        this.groups.push(this.fullGroups[i]);
      }
    }
  }

  setUndefinedQueueArn(event: any, queue: any){
    if(event.index != -1){
      queue.queueConfig.arn = this.undefinedQueues[event.index].Arn;
    }
  }

  //update for group
  updateGroup(groupData){
    if(groupData.item.groupId == "" || !groupData.item.groupId){
      let guid = this.newGUID();
      groupData.item.groupId = guid;
    }
    let collection = {
      collectionName: "queueGroupList",
      Key: "0",
      data: []
    };

    if(!this.uniqueGroupName(groupData.item)){
      this.lambdaMessage2 = "Group name is not unique"
      this.lambdaError2 = true;
      this.changeLOB(this.lobSelected);
      return;
    }
    
    //Find new group
    let index = -1;
    for(let i=0;i<this.fullGroups.length;i++){
      if(this.fullGroups[i].groupId == groupData.item.groupId){
        index = i;
      }
    }
    console.log("index:" + index)
    //Do something to the new group
    if(index == -1){
      //add new
      console.log("ADD")
      this.fullGroups.push(groupData.item);
    }else{
      console.log("NOT ADDING")
      if(groupData.action == "put"){
        console.log("UPDATE")
        this.fullGroups.splice(index, 1, groupData.item);
      }else if (groupData.action == "delete"){
        console.log("DELETE")
        this.fullGroups.splice(index, 1);
      }
    }
    //prepare for lambda sending
    collection.data = this.fullGroups;
    let data = {item: collection, action: "put"}
    this.telecomService.saveRow(data, environment.GroupsLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError2 = false;
        if(groupData.action == "put"){
          this.lambdaMessage2 = "Data saved successfully.";
        }
        else if(groupData.action == "delete"){
          this.lambdaMessage2 = "Data deleted successfully.";
        }
      }
      else{
        this.lambdaError2 = true;
        this.lambdaMessage2 = data.Error.message;
        console.log("Error: ", data.Error)
        if(groupData.action == "put"){
          this.lambdaMessage2 = "An error occurred, data was not saved successfully.";
        }
        else if(groupData.action == "delete"){
          this.lambdaMessage2 = "An error occurred, data was not deleted successfully.";
        }
      }
    });
  }

  uniqueGroupName(groupItem: any){
    let name = groupItem.groupName;
    let id = groupItem.groupId
    for(let x=0; x < this.fullGroups.length; x++){
      if(this.fullGroups[x].groupName.toLowerCase() == name.toLowerCase() && this.lobSelected == this.fullGroups[x].LOB && this.fullGroups[x].groupId != id){
        return false;
      }
    }
    return true;
  }

  //returns a list of all queues except the one with a matching id parameter
  getOverflowList(queueId: string){
    let temp = [];
    for(let x = 0; x < this.fullData.length; x++){
      if(!(this.fullData[x].queueId == queueId)){
        temp.push(this.fullData[x]);
      }
    }
    return temp;
  }

  getQueueNameByArn(arn: string){
    for(let x=0; x < this.fullData.length; x++){
      if(this.fullData[x].queueConfig.arn == arn){
        return this.fullData[x].queueName;
      }
    }
    return 'Queue not found'
  }

  setOverFlow(queue: any){
    if(this.overFlowSelect=="transfer"){
      queue.queueConfig.overFlow = this.transferObj;
    }else if(this.overFlowSelect=="queue"){
      queue.queueConfig.overFlow = this.queueObj;
    }else if(this.overFlowSelect=="none"){
      queue.queueConfig.overFlow = {};
    }
    console.log("queue: ", queue);
  }

  onButtonEvent(event: any){
    console.log(event);
    if(event.button == 'create' || event.button == 'edit'){
      this.queueNameOptions = [];
      this.getUndefinedQueues();
    }else if(event.button == 'confirm'){
      this.updateItem({action: 'put', item: event.item});
    }else if(event.button == 'delete'){
      this.updateItem({action: 'delete', item: event.item});
    }
  }

  validate(item){
    this.lambdaMessage = '';
    this.lambdaError = false;

    //Confirm all fields are filled
    console.log("validating: ", item)

    if(!item.queueName){
      this.lambdaMessage = "Queue Name is required."
      this.lambdaError = true;
      return false;
    }

    if(!this.uniqueQueueName(item)){
      this.lambdaMessage = "Queue Name is not unique"
      this.lambdaError = true;
      return false;
    }

    if(!this.uniqueQueueARN(item)){
      this.lambdaMessage = "Duplicate queue ARN is not allowed"
      this.lambdaError = true;
      return false;
    }

    if(!item.queueConfig.arn){
      this.lambdaMessage = "Queue Arn is required."
      this.lambdaError = true;
      return false;
    }

    if(!item.language){
      this.lambdaMessage = "language is required."
      this.lambdaError = true;
      return false;
    }

    if(!item.queueConfig.agentWhisper){
      this.lambdaMessage = "whisper is required."
      this.lambdaError = true;
      return false;
    }

    // let arnPattern: RegExp = new RegExp(/arn:(aws[a-zA-Z-]*)?:lambda:[a-z]{2}((-gov)|(-iso(b?)))?-[a-z]+-\d{1}:\d{12}:function:[a-zA-Z0-9-_]+(:(\$LATEST|[a-zA-Z0-9-_]+))?/)
    // let phoneNumberPattern: RegExp = new RegExp(/^\+[0-9]{11}$/)
    // let tenNumberPattern: RegExp = new RegExp(/^[0-9]{10}$/)
    // let elevenNumberPattern: RegExp = new RegExp(/^[0-9]{11}$/)
    // if(!arnPattern.test(item.queueConfig.arn)){
    //   return false;
    // }

    if(item.queueConfig.voiceMail){
      if(!this.validatePhone(item.queueConfig.voiceMail)){
        return false;
      }
    }
    
    if(item.queueConfig.overFlow.behavior == "transfer"){
      item.queueConfig.overFlow.arn = null;

      if(!item.queueConfig.overFlow.transferNumber){
        this.lambdaMessage = "transfer number is required."
        this.lambdaError = true;
        return false;
      }else if(!this.validatePhone(item.queueConfig.overFlow.transferNumber)){
          return false;
      }
    }else if(item.queueConfig.overFlow.behavior == "queue"){
      item.queueConfig.overFlow.transferNumber = null;
      if(!item.queueConfig.overFlow.arn){
        this.lambdaMessage = "Overflow Queue is required."
        this.lambdaError = true;
        return false;
      }
      // if(!arnPattern.test(item.queueConfig.overFlow.arn)){
      //   return false;
      // }
    }
    return true;
  }

  cleanPhoneNumber(number: string){
    number = number.split("-").join("");
    number = number.split("(").join("");
    number = number.split(")").join("");
    console.log(number);
    return number;
  }

  validatePhone(numString: any){
    this.lambdaMessage = '';
    this.lambdaError = false;
    if(!(numString[0] == '+' && numString[1] == 1)){
      this.lambdaError = true;
      this.lambdaMessage = "Missing '+1' at the beginning of phone number";
      return false;
    }
    //scrub input
    let test = numString;
    if(test.startsWith('+')){
      test = test.slice(1, test.length);
    }
    //is digital
    let reg = new RegExp('^[0-9]*$');
    if(!reg.test(test)){
      this.lambdaError = true;
      this.lambdaMessage = 'Invalid phone number'
      return false;
    }
    //proper length and extension
    if(test.length < 11){
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too short'
      return false;
    }
    if(test.length > 11){
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too long'
      return false;
    }
    return true
  }

  uniqueQueueName(item: any){
    let name = item.queueName
    let id = item.queueId
    for(let x=0; x< this.fullData.length; x++){
      if(this.fullData[x].queueName.toLowerCase() == name.toLowerCase() && this.fullData[x].queueId != id)
      return false;
    }
    return true;
  }

  uniqueQueueARN(queue: any){
    for(let x=0; x < this.fullData.length; x++){
      if(this.fullData[x].queueConfig.arn == queue.queueConfig.arn && this.fullData[x].queueId != queue.queueId){
        return false
      }
    }
    return true;
  }
  buildLangMap(){
    this.telecomService.getLanguages().then((resultData:any)=>{
      console.log("get language result: ", resultData);
      this.languages = resultData.languages;
      this.langMap = new Map<string, any>();
      //if there is no language set
      this.langMap.set(undefined, {groupName:""});
      this.langMap.set(null, {groupName:""});
      this.langMap.set("", {groupName:""});
      //
      for(let i=0;i<this.languages.length;i++){
        this.langMap.set(this.languages[i][1], this.languages[i][0])
      }
      console.log(this.langMap);
    });
  }
}
